import { post } from "app/utils/axios/kheti"

interface PriceChangeResponse {
  id: number
  latest_status: string
  request_type: string
  old_price: string
  suggested_price: string
  inventory_source: string
  role_type: string
  reason?: string,
}

const createPriceChangeRequest = async (
  vendorId?: number,
  productVariantId?: number,
  oldPrice?: number,
  suggestedPrice?: string,
  inventorySource?: string,
  role_type?: string,
  reason?: string,
) => {
  
  try {
    const url = `/approvals/v1/change/requests${role_type ? `?role_type=${role_type}` : ''}`
    return await post<PriceChangeResponse>(url, {
      request_type: "PRICE_CHANGE",
      vendor_id: vendorId,
      product_variant_id: productVariantId,
      old_price: oldPrice,
      suggested_price: suggestedPrice,
      inventory_source: inventorySource,
      reason: reason,
    })
  } catch (e) {
    return e
  }
}

export default createPriceChangeRequest
